/**
 * @format
 */
import { api } from '@/scripts/api';

export const ThirdPartyServices = {
    getAuthorizeUrl(identityProvider) {
        return new Promise((resolve, reject) => {
            const apiUrl = `/ms/auth/v1/third-party-auth/authorize-url/${identityProvider}`;
            api.get(apiUrl).then(resolve).catch(reject);
        });
    },

    authorizeUser(identityProvider, code) {
        return new Promise((resolve, reject) => {
            const apiUrl = `/ms/auth/v1/third-party-auth/${identityProvider}/callback?code=${code}`;
            api.get(apiUrl).then(resolve).catch(reject);
        });
    },
};
